import SpaceLogin from "assets/img/space-login.png";
import { StarDecorations } from "components/ui/StarDecorations";
import { useLocation } from "react-router-dom";
import { useControlDate } from "hooks/useControlDate";

function formatDate(value: Date | string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", timeZone: "America/Sao_Paulo" });
}

export function NotFound() {
  const location = useLocation();
  const state = location.state as { reason?: string; category?: string | string[] } | null;
  const isCategoryUser = state?.reason === 'category';

  const periodoConexao = useControlDate("periodo_cadastro_conexao");
  const aprovacaoGestor = useControlDate("aprovacao_gestor_conexao");

  return (
    <div id="notfound-wrapper" className="min-h-screen">
      <div className="relative flex flex-col w-full min-h-screen bg-gradient-to-br from-blue-bb via-blue-bb-1 to-blue-bb-5 overflow-x-hidden">
        <main 
          className="flex flex-col lg:flex-row flex-1 items-center justify-center px-4 sm:px-6 md:px-10 lg:px-16 relative gap-8 lg:gap-12"
          role="main"
        >
          <article className="w-full max-w-xl lg:max-w-2xl z-10 text-center lg:text-left">
            {isCategoryUser ? (
              <div className="space-y-4 sm:space-y-5 lg:space-y-6">
                <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-yellow-bb leading-tight">
                  Fique ligado nas datas!
                </h1>
                <div className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium space-y-4">
                   {/* <p className="leading-relaxed">
                    O período de inscrição para as categorias <span className="text-pink-bb font-bold">"ECBB"</span> e <span className="text-pink-bb font-bold">"Simplificação e Eficiência"</span> será de <span className="text-yellow-bb font-bold">{formatDate(periodoConexao?.dataInicio)}</span> até <span className="text-yellow-bb font-bold">{formatDate(periodoConexao?.dataFim)}</span>.
                  </p> */}
                  <p className="leading-relaxed">
                    O período de <span className="text-yellow-bb font-bold">{formatDate(aprovacaoGestor?.dataInicio)}</span> até <span className="text-yellow-bb font-bold">{formatDate(aprovacaoGestor?.dataFim)}</span>, é de apreciação das iniciativas das categorias <span className="text-pink-bb font-bold">"Negócios e Atendimento"</span> e <span className="text-pink-bb font-bold">"Pilar de Sustentação"</span>!
                  </p>
                </div>
              </div>
            ) : (
              <>
                <div className="space-y-2 sm:space-y-3 lg:space-y-2 mb-4 sm:mb-5 lg:mb-6">
                  <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-pink-bb leading-tight">
                    Ops... quase lá!
                  </h1>
                  <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-yellow-bb leading-tight">
                    Você não possui <br></br> o(s) pré-requisito(s) obrigatórios para participação <br></br> no Prêmio BB 2026. <br></br> Para mais detalhes, <br></br> consultar IN 403, item 7.2.3.
                  </h2>
                </div>

                <div className="text-sm sm:text-base md:text-lg lg:text-xl text-white font-medium">
                  <p className="leading-relaxed">
                    Mesmo assim, não deixe essa energia de lado! <br></br>
                    Em breve você vai conhecer as iniciativas que inspiram e transformam!
                  </p>
                </div>
              </>
            )}
          </article>

          <aside 
            className="hidden lg:flex relative flex-shrink-0 opacity-50"
            aria-hidden="true"
          >
            <img
              src={SpaceLogin}
              alt=""
              className="w-full max-w-md xl:max-w-2xl h-auto object-contain z-20"
              loading="lazy"
              decoding="async"
            />
          </aside>
        </main>

        <div aria-hidden="true" className="hidden md:block pointer-events-none">
          <StarDecorations count={25} density="medium" />
        </div>
      </div>
    </div>
  );
}

